<template>
    <div :class="['col-12', userTableView ? 'black-bg' : '']">
        <template  v-if="shop">
            <shop-table-item :tableClass="tableClass"
                            :key="shop.id"
                            :open="open"
                            :index="index"
                            :showIcon="true"
                            :shop="shop"
                            :userTableView="userTableView"
                            :hideAddition="hideAddition"
                            @removeShopFromUser="$emit('removeShopFromUser', $event)"
                            @open="handleOpen"
                            @changeTab="$emit('changeTab', $event)"
                            @addUserToShop="$emit('addUserToShop', $event)"
                            @editShop="$emit('editShop')"/>
            <transition-group name="slide-up" tag="div" v-if="shop.users">
                <template v-if="open && loaded">
                    <user-table-item
                        :open="open"
                        :showIcon="false"
                        :showButtons="false"
                        :shopView="true"
                        :user="user"
                        v-for="(user, index) in shop.users"
                        :key="'shop-table-user-row-' + user.id + index"
                    />
                </template>
            </transition-group>
        </template>
    </div>
</template>
<script type="text/babel">
import UserTableItem from '../User/UserTableItem';
import ShopTableItem from './ShopTableItem';
import { mapActions } from 'vuex';

export default {
    name: 'shop-table-row',
    components: {
        UserTableItem,
        ShopTableItem
    },
    data () {
        return {
            open: false,
            loaded: false
        };
    },
    props: {
        shop: {
            type: [Array, Object]
        },
        level: {
            default: 0
        },
        hideAddition: {
            type: Boolean,
            default: false
        },
        tableClass: {
            type: String,
            default: 'table table-striped'
        },
        userTableView: {
            type: Boolean,
            default: false
        },
        tableUid: {
            type: String
        },
        index: ''
    },
    watch: {
        tableUid: 'showUsers'
    },
    methods: {
        ...mapActions(['GetUser']),
        handleOpen () {
            this.open = !this.open;
            if(this.open) {
                this.showUsers();
            }
        },
        async showUsers (override) {
            if(this.shop.users && !this.loaded || override) {
                this.shop.users = await this.$utils.resolvePromises(
                    this.shop.users.map(({id}) => this.GetUser(id))
                );
                this.loaded = true;
            }
        }
    },
    created () {
        this.$watch('shop.users', (newVal) => {
            if(newVal && newVal[0] && !newVal[0].role) {
                this.showUsers(true);
            }
        });
    }
};

</script>

